export default __webpack_public_path__ + "static/media/rake-structure.dc99c392.webp";